export const showHiddenBlocksDescriptions = {
  enabled:
    'Los bloques que no coincidan con tu configuración de preview se seguirán mostrando, para que puedas seguir editándolos.',
  disabled:
    'Los bloques que no coincidan con tu configuración de preview están ocultos. Actívalo para verlos y editarlos.',
}
